<template>
  <div class="c-services component">
    <h3 class="text-upper mb--2">USŁUGI DO WYKONANIA</h3> 
    <div class="c-services__list">
      <div v-for="(group, key) in getAdvisonGroups"
        :class="[`c-services__group`, { 'c-services__group--active': group.toggle }]" :key="key" ref="element">
        <div class="c-services__group__name" @click="group.toggle = !group.toggle">
          <span>{{ group.name }} <small>Wybrano: {{ getSelectedServicesCountByGroup(group.id) }}</small></span> <span
            class="c-services__group__tick">&#10094;</span>
        </div>
        <div v-if="group.toggle">
          <label v-for="service in getServicesByGroup(group.id)" 
            :class="['c-services__service', { 'c-services__service--disabled': isDisabled(service) }]" 
            :key="service.val">
            <input type="checkbox" :value="service.val" class="mt--1" @change="pushService(service)"
              :checked="lead.services_val && lead.services_val.includes(service.id)" 
              :disabled="isDisabled(service)" />
            <div class="c-services__service__text">
              <span>{{ service.name }}</span>
              <small v-if="service.description && service.description.length > 0" v-html="`<br>` + service.description"></small>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import lead from "@/mixins/lead.js";

export default {
  data() {
    return {
      blockServices: false,
    };
  },
  mixins: [lead],
  computed: {
    getServicesMiddleware() {
      return this.getOperations;
    },
    getServicesByGroup() {
      return (key) => {
        return this.getServicesMiddleware.filter(service => service.group_id == key);
      };
    },
    getSelectedServicesCountByGroup() {
      return (key) => this.getServicesByGroup(key).filter(service => this.lead.services_val && this.lead.services_val.includes(service.id)).length;
    }
  },
  methods: {
    ...mapActions({
      fetchOperations: 'definitions/fetchOperations'
    }),
    handleClickOutside(event) {
      if (!this.$refs.element) return;
      const clickedInsideElement = this.$refs.element.some(element => element.contains(event.target));
      if (!clickedInsideElement) {
        this.getServicesGroups.forEach(group => {
          group.toggle = false;
        });
      }
    },
    isDisabled(service) {
      if (service.disabled) return true;

      const selected = this.lead.services_val || [];
      const is259Selected = selected.some(id => id == 259);

      if (is259Selected) {
        return service.id != 259;
      } else if (selected.length > 0) {
        return service.id == 259;
      }

      return false;
    },
    pushService(service) {
      const index = this.lead.services_val.indexOf(service.id);
      
      if (index === -1) {
        this.lead.services_val.push(service.id);
        this.lead.services_name.push(service.name);
      } else {
        this.lead.services_val.splice(index, 1);
        this.lead.services_name.splice(index, 1);
      }

      const selected = this.lead.services_val
        .map(id => this.getServicesMiddleware.find(s => s.id === id))
        .filter(Boolean);

      const priority = selected.filter(s => s.group && s.group.important == 1);
      
      const target = priority.length > 0 
        ? priority[priority.length - 1] 
        : selected[selected.length - 1];

      this.lead.operation_id = target ? target.id : null;
      this.lead.operation_group_id = target ? target.group_id : null;

      this.lead = {
        ...this.lead
      };
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.fetchOperations({ brand_id: this.lead.brand_id });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss">
.c-services {
  &__group {
    margin-bottom: 1rem;
    $t: &;

    &__name {
      background-color: $brightgray;
      font-weight: bold;
      font-size: 1.25rem;
      padding: .5rem 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      small {
        font-size: .9rem;
        font-weight: normal;
      }
    }

    &__tick {
      text-align: center;
      color: $blue;
      transform: rotate(-90deg);
    }

    &--active {
      #{$t}__tick {
        transform: rotate(90deg);
      }
    }
  }

  &__service {
    display: flex;
    align-items: flex-start;
    margin: .25rem 0;
    transition: opacity 0.2s ease-in-out;

    &--disabled {
      opacity: 0.4;
      cursor: not-allowed;

      input {
        cursor: not-allowed;
      }
    }

    &__text {
      margin-top: .7rem;
      margin-left: .5rem;
      small {
        color: #777;
      }
    }
  }
}
</style>